import { useState } from "react";
import { FC, MouseEvent } from "react";
import { InputDinamycPlaceholder, ButtonBasic, Checkbox, DropDownSelector } from '@lk-gtcom/ecomlab-components';
import customHeaders, { getSpace } from '../../../common/headers';
import useGeneralStore from "../../../store/general";
import { ModalComponent } from "../../../components/Modal/ModalComponent/ModalComponent";
import { useResponseHandler } from "../../../common/auth";
import "./ModalSettingMasterProduct.scss";

const option_prop = [
  { label: 'Текст', value: 'str' },
  { label: 'Целое число', value: 'int' },
  { label: 'Дробное число', value: 'float' },
  { label: 'Логическое значение (Да / Нет)', value: 'bool' },
]

type CurrentRow = {
  attribute_id: string,
  Название: string,
  Описание: 'string',
  "Принимает список значений": string,
  "Тип значения": string
}

interface ModalSettingMasterProductProps {
  setIsModal: (isOpen: boolean) => void;
  currentRow: CurrentRow,
  setСurrentRow: (currentRow: CurrentRow | null) => void,
}

const ModalSettingMasterProduct: FC<ModalSettingMasterProductProps> = ({
  setIsModal,
  currentRow,
  setСurrentRow
}) => {

  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleTableResponse, handleRequestError } = useResponseHandler();

  const current_value_prop = option_prop.filter(({ label }) => label == currentRow?.["Тип значения"])
  const [name, setName] = useState<string>(currentRow ? currentRow?.['Название'] : '')
  const [description, setDescription] = useState<string>(currentRow ? currentRow?.['Описание'] : '')
  const [isList, setIsList] = useState<boolean>(currentRow?.['Принимает список значений'] == 'Да' ? true : false)
  const [selectedValue, setSelectedValue] = useState(currentRow ? current_value_prop[0] : option_prop[0])
  const [listItem, setListItem] = useState('')

  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    setСurrentRow(null)
    setIsModal(false)
  };

  const handleChangeListItem = (e: string) => {
    setListItem(e);
  }

  const handleChangeName = (e: string) => {
    setName(e);
  }

  const handleChangeDescription = (e: string) => {
    setDescription(e);
  }

  const handleChangeList = (e: boolean) => {
    setIsList(!isList);
  }

  const handleClickBtn = (e: MouseEvent<HTMLDivElement>) => {
    fetchAddField()
    setСurrentRow(null)
    setIsModal(false)
  }

  // Добавление/изменение характеристики
  const fetchAddField = () => {
    let url = `https://apps1.ecomru.ru:4463/custom_attrs/${currentRow ? 'update' : 'create'}`

    const body = JSON.stringify({
      attribute_id: currentRow ? currentRow.attribute_id : '',
      attribute_name: name,
      description: description,
      is_array: isList,
      data_type: selectedValue?.value
    });

    fetch(url, { body, method: currentRow ? 'PUT' : 'POST', headers })
      .then(handleTableResponse)
      .then((json) => setСurrentRow(null))
      .catch(handleRequestError);
  };

  return (
    <ModalComponent
      title={currentRow ? "Редактирование характеристики" : "Новая характеристика"}
      onClose={handleClick}
      style={{
        maxWidth: '500px',
        height: 'auto',
        overflow: 'visible'
      }}
      styleContent={{
        overflow: 'visible'
      }}
      child={<div className="modal-add-new-field">
        <InputDinamycPlaceholder
          placeholder='Название'
          onChange={handleChangeName}
          changeValue={name}
          size='s'
        />

        <InputDinamycPlaceholder
          placeholder='Описание'
          onChange={handleChangeDescription}
          changeValue={description}
          size='s'
        />

        <Checkbox
          value={isList}
          onChange={handleChangeList}
        >Список</Checkbox>

        <DropDownSelector
          options_prop={option_prop}
          placeholder='Формат данных'
          width='100%'
          state={selectedValue}
          setState={(e: any) => setSelectedValue(e)}
          isClearable={false}
          maxWidth='100%'
        />

        <ButtonBasic
          green
          text='Применить'
          onClick={handleClickBtn}
        />
      </div>}
    />
  );
};

export { ModalSettingMasterProduct };